import React from 'react';

const ListScreenKeys = ({ documentData }) => {
  const record = documentData;
  return [
    {
      label: 'Sales Manager',
      value: record?.account_manager_info?.account_manager_id ? (`${record?.account_manager_info?.first_name} ${record?.account_manager_info?.last_name}`) : 'N/A',
    },
    {
      label: 'Items',
      value: record?.cn_lines?.length || 0,
    }];
};

export default ListScreenKeys;
